"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationGroupFactory = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const defaultAggregationFns_1 = require("./AggregationFunctions/defaultAggregationFns");
const debug = datamodel_core_1.DEBUG_OVERRIDE || (datamodel_core_1.NOT_LAMBDA && false);
const AggregationGroupFactory = (ModelClasses) => { var _a; return _a = class AggregationGroup extends datamodel_core_1.Group {
        constructor({ dailyStateHistory, ...ob }) {
            super({ ...ob, type: ob.type ?? _a.typeName });
            this.getSupportedTypeClass = () => this.supportedType && ModelClasses[this.supportedType];
            this.getStateKeys = () => {
                const stateKeys = [...this.getSupportedTypeStateKeys()];
                debug && console.log('Aggregation Group State keys', stateKeys);
                return stateKeys;
            };
            this.getSupportedTypeStateKeys = () => {
                let stateAttKeys = [];
                if (this.supportedType) {
                    let instance = undefined;
                    if (ModelClasses[this.supportedType]) {
                        instance = new ModelClasses[this.supportedType]({});
                    }
                    if (instance && typeof instance.getStateKeys === 'function') {
                        stateAttKeys = instance.getStateKeys();
                    }
                }
                debug && console.log({ supType: this.supportedType, stateAttKeys });
                return stateAttKeys;
            };
            this.getAggregationFns = () => {
                let aggregationFns = undefined;
                const supportedTypeClass = this.getSupportedTypeClass();
                if (supportedTypeClass && supportedTypeClass.aggregationFns) {
                    aggregationFns = supportedTypeClass.aggregationFns;
                }
                return aggregationFns;
            };
            this.aggregateMetrics = (groupedItems, group) => {
                const stateAttKeys = this.getSupportedTypeStateKeys();
                const supportedTypeClass = this.getSupportedTypeClass();
                const aggregationFns = this.getAggregationFns();
                if (stateAttKeys && supportedTypeClass) {
                    const supportedTypeInstances = groupedItems.map((item) => new supportedTypeClass(item)).filter((instance) => instance);
                    stateAttKeys.forEach((k) => {
                        if (aggregationFns && aggregationFns[k]) {
                            this[k] = aggregationFns[k].call(this, supportedTypeInstances, group);
                        }
                        else {
                            this[k] = (0, defaultAggregationFns_1.aggregateMean)(supportedTypeInstances, k);
                            // on the basis that mean is more often appropriate than total
                        }
                    });
                    this.updateHistory(stateAttKeys);
                }
            };
            this.getStateSnapshot = (aggregationKeys) => {
                const timestamp = Date.now();
                const state = aggregationKeys.reduce((acc, k) => Object.assign(acc, { [k]: this[k] }), {});
                return { timestamp, state };
            };
            this.updateHistory = (aggregationKeys) => {
                const stateSnapshot = this.getStateSnapshot(aggregationKeys);
                this.dailyStateHistory.push(stateSnapshot);
            };
            const stateAttKeys = this.getSupportedTypeStateKeys();
            stateAttKeys?.forEach((k) => !this[k] && (this[k] = undefined));
            const params = { ..._a.getDefaultHistoryObjectParams(datamodel_core_1.DataLifeCyclePeriod.DAILY), ...dailyStateHistory };
            this.dailyStateHistory = new datamodel_core_1.HistoryStore(params);
        }
        getUserAttributes() {
            const { Group, Ruleset, Horse, Silo, Tank, ...retained } = super.getUserAttributes();
            return {
                ...retained,
            };
        }
    },
    _a.typeName = 'AggregationGroup',
    _a.defaultDailyHistoryObjectSystemProperties = {
        autoTrim: true,
        maxAgeMS: datamodel_core_1.Milliseconds.DAY * 50,
        maxLength: 50,
    },
    _a.getDefaultHistoryObjectParams = (period) => {
        let systemProperties;
        switch (period) {
            case datamodel_core_1.DataLifeCyclePeriod.DAILY:
                systemProperties = _a.defaultDailyHistoryObjectSystemProperties;
                break;
            default:
                systemProperties = _a.defaultDailyHistoryObjectSystemProperties;
        }
        return {
            index: [],
            timestamp: [],
            systemProperties,
        };
    },
    _a; };
exports.AggregationGroupFactory = AggregationGroupFactory;
